export default __webpack_public_path__ + "static/media/mini_small.7c64f38a.png";